import React from 'react';

import LearnMore from './LearnMore';
import FaqLanding from './FaqContentLanding';

import './LandingFaq.css';
import FaqPanel from '../TorontoFleets/Shared/FaqPanel';
import FaqLandingSF from './FaqContentLandingSF';

const LandingFaq = ({ isVisible }) => (
  <div className="landing__section">
    <div className="container landing-faq">
      <h2>Frequently Asked Questions</h2>
      <FaqPanel faq={FaqLandingSF} />
      <LearnMore />
    </div>
  </div>
);

export default LandingFaq;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageLA/LandingFaq.js